<template>
    <div id="app">
        <!-- 首页、home文件夹下的页面、新闻中心、党群工作、纪检监察、联系我们、政务公开和搜索结果页面不需要显示后台管理布局 -->
        <div
            v-if="$route.path === '/' || $route.path.includes('/home/') || $route.path.startsWith('/about') || $route.path.startsWith('/news') || $route.path.startsWith('/party') || $route.path.startsWith('/supervision') || $route.path.startsWith('/discipline_inspection') || $route.path.startsWith('/contact_us') || $route.path.startsWith('/open_affairs') || $route.path === '/search_result' || $route.path.startsWith('/tender')">
            <router-view></router-view>
        </div>
        <!-- 其他页面根据是否登录显示不同的布局 -->
        <div v-else>
            <div v-if="isLoggedIn">
                <el-container>
                    <el-container>
                        <el-aside width="180px">
                            <div class="logo flex justify-center">狮城CMS内容管理系统</div>

                            <el-menu :default-active="$route.path" :router="true" class="el-menu-vertical-demo"
                                background-color="#3E4558" text-color="#fff">

                                <el-menu-item index="/content" @click="to('/content', '内容管理',)">
                                    <template slot="title">
                                        <i class="el-icon-document"></i>
                                        <span>内容管理</span>
                                    </template>
                                </el-menu-item>
                                <el-menu-item index="/category" @click="to('/category', '分类管理',)">
                                    <template slot="title">
                                        <i class="el-icon-s-grid"></i>
                                        <span>分类管理</span>
                                    </template>
                                </el-menu-item>
                                <el-menu-item index="/user" @click="to('/user', '用户管理',)">
                                    <template slot="title">
                                        <i class="el-icon-user"></i>
                                        <span>用户管理</span>
                                    </template>
                                </el-menu-item>
                                <el-menu-item index="/message" @click="to('/message', '留言管理',)">
                                    <template slot="title">
                                        <i class="el-icon-chat-line-round"></i>
                                        <span>留言管理</span>
                                    </template>
                                </el-menu-item>
                                <el-menu-item index="/article" @click="to('/article', '单页文章管理',)">
                                    <template slot="title">
                                        <i class="el-icon-document"></i>
                                        <span>单页文章管理</span>
                                    </template>
                                </el-menu-item>
                                <el-menu-item index="/contact" @click="to('/contact', '联系方式设置',)">
                                    <template slot="title">
                                        <i class="el-icon-phone"></i>
                                        <span>联系方式设置</span>
                                    </template>
                                </el-menu-item>
                                <el-menu-item index="/system" @click="to('/system', '系统设置',)">
                                    <template slot="title">
                                        <i class="el-icon-setting"></i>
                                        <span>系统设置</span>
                                    </template>
                                </el-menu-item>
                            </el-menu>
                        </el-aside>
                        <el-container>
                            <el-header class="d-flex justify-between">
                                <div>
                                    {{ title }}
                                </div>
                                <el-dropdown @command="clickdrop">
                                    <span class="el-dropdown-link">
                                        {{ Usrinfo.username || '管理员' }}<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="back"><i
                                                class="el-icon-back"></i>返回首页</el-dropdown-item>
                                        <el-dropdown-item command="ouit"><i
                                                class="el-icon-switch-button"></i>退出登录</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </el-header>
                            <el-main>
                                <router-view></router-view>
                            </el-main>
                        </el-container>
                    </el-container>
                </el-container>
            </div>
            <!-- 未登录时直接显示路由视图（登录页面） -->
            <div v-else>
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            title: '内容管理',
            index: '/',
            Usrinfo: {},
            isLoggedIn: true
        }
    },
    mounted() {
        // this.checkLoginStatus()
    },
    watch: {
        // 监听路由变化，检查登录状态
        '$route'(to, from) {
            //   this.checkLoginStatus()
            this.title = to.meta.title || this.title
            this.index = to.path
            console.log('this route ====================> path', this.$route.path);
            console.log('get -------------> query', this.$route.query);
        }
    },
    methods: {
        // 检查登录状态
        checkLoginStatus() {
            try {
                const token = localStorage.getItem('TSB_token')
                const userInfo = localStorage.getItem('TSB_user_info')

                this.isLoggedIn = !!token

                if (this.isLoggedIn && userInfo) {
                    this.Usrinfo = JSON.parse(userInfo)
                }
            } catch (error) {
                console.error('检查登录状态失败:', error)
                this.isLoggedIn = false
                this.Usrinfo = {}
            }
        },
        clickdrop(val) {
            console.log(val)
            if (val == "ouit") {
                this.$confirm("您确定要登出当前帐号吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    // 删除本地缓存
                    localStorage.removeItem('token')
                    localStorage.removeItem('user_info')
                    localStorage.removeItem('TSB_token')
                    localStorage.removeItem('TSB_user_info')

                    this.$message({
                        type: "success",
                        message: "退出成功!",
                    });

                    // 更新登录状态
                    this.isLoggedIn = false
                    this.Usrinfo = {}

                    // 重定向到登录页
                    setTimeout(() => {
                        this.$router.push('/login')
                    }, 1000);
                });
            } else if (val == "back") {
                this.$confirm("您确定要返回首页吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    //删除本地缓存
                    location.href = "";
                });
            }
        },
        initUser() {
            // 使用CMS系统的API获取当前用户信息
            this.$api.center.getCurrentUser({}).then(res => {
                if (res.status == 1) {
                    this.Usrinfo = res.data
                    localStorage.setItem('userInfo', JSON.stringify(res.data))
                    console.log('用户信息初始化成功:', this.Usrinfo)
                } else {
                    console.error('获取用户信息失败:', res)
                }
            }).catch(err => {
                console.error('用户信息请求错误:', err)
                // 模拟用户数据用于演示
                this.Usrinfo = {
                    user_name: '管理员',
                    realname: '系统管理员',
                    role_name: '超级管理员'
                }
            })
        },
        toHome() {
            this.$router.push('/cms/content')
        },
        to(path, title) {
            this.title = title
            this.index = path
            this.$router.push({
                path
            })
            console.log('导航到:', path, '标题:', title)
        },
        //时间戳转 日期
        formatDate(obj) {
            return new Date(parseInt(obj) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
        },
        deepClone(obj) {
            console.log("输出结构", obj)
            let result
            if (typeof obj !== 'object' || obj === null) {
                return obj
            }
            // 判断是对象还是数组
            if (obj instanceof Array) {
                result = []
            } else {
                result = {}
            }
            for (let key in obj) {
                // 保证key不是原型上的属性
                if (obj.hasOwnProperty(key)) {
                    // 递归调用
                    result[key] = this.deepClone(obj[key])
                }
            }
            return result
        }

    },
}
</script>

<style lang="scss">
* {
    box-sizing: border-box;
}

body {
    padding: 0;
    margin: 0;
}

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    color: #2c3e50;
    // margin-top: 60px;
}

.el-aside {
    background: #3E4558;
    color: #fff;
    // width: 183px;
    min-height: 100vh;

    .logo {
        display: flex;
        align-items: center;
        height: 60px;
        padding: 15px;
    }
}

.el-header {
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
}

.el-main {
    background: #f9f9f9;
}

.d-flex {
    display: flex !important;
}

.flex {
    display: flex !important;
}

.flex-wrap {
    flex-wrap: wrap;
}

.align-items-center {
    align-items: center !important;
}

.align-center {
    align-items: center !important;
}

.flex-column {
    flex-direction: column !important;
}

.align-items-end {
    align-items: flex-end !important;
}

.justify-content-around {
    justify-content: space-around !important;
}

.justify-around {
    justify-content: space-around !important;
}

.justify-content-between {
    justify-content: space-between !important;
}

.justify-between {
    justify-content: space-between !important;
}

.justify-content-center {
    justify-content: center !important;
}

.justify-center {
    justify-content: center !important;
}

.justify-content-end {
    justify-content: flex-end !important;
}

.justify-end {
    justify-content: flex-end !important;
}

.rounded-circle {
    border-radius: 50% !important;
}

.text-center {
    text-align: center;
}

.yy {
    box-shadow: 0 3rpx 6rpx rgba(0, 0, 0, 0.07);
}

.height88 {
    height: 88rpx;
}

.wh107 {
    width: 107rpx;
    height: 107rpx;
}

.bold {
    font-weight: bold;
}

.fs18 {
    font-size: 9px;
    line-height: 12px !important;
}

.fs20 {
    font-size: 10px;
    line-height: 10px;
}

.fs22 {
    font-size: 11px;
    line-height: 22px;
}

.fs24 {
    font-size: 12px;
    line-height: 12px;
}

.fs26 {
    font-size: 13px;
    line-height: 13px;
}

.fs28 {
    font-size: 14px;
    line-height: 14px;
}

.fs30 {
    font-size: 15px;
    line-height: 15px;
}

.fs32 {
    font-size: 16px;
    line-height: 16px;
}

.fs34 {
    font-size: 17px;
    line-height: 17px;
}

.fs36 {
    font-size: 18px;
    line-height: 18px;
}

.fs38 {
    font-size: 19px;
    line-height: 19px;
}

.fs40 {
    font-size: 20px;
    line-height: 20px;
}

.fs44 {
    font-size: 22px;
    line-height: 22px;
}

.fs46 {
    font-size: 23px;
    line-height: 23px;
}

.fs48 {
    font-size: 24px;
    line-height: 24px;
}

.textColorFFF {
    color: #FFFFFF;
}

.textColor7F7 {
    color: #7F7F7F;
}

.textColorBEBEBE {
    color: #BEBEBE !important;
}

.textColorF5 {
    color: #5F5F5F;
}

.textColor000 {
    color: #000000;
}

.textColor333 {
    color: #333333;
}

.textColor666 {
    color: #666666;
}

.textColor999 {
    color: #999999;
}

.textColorF12 {
    color: #F12;
}

.textColorAAB {
    color: #AAB1C0;
}

.textColor939 {
    color: #939393;
}

.bgWri {
    background: #FFFFFF;
}

.bgF4F {
    background: #F4F4F4 !important;
}

.pr {
    position: relative !important;
}

.pa {
    position: absolute !important;
}

.pf {
    position: fixed !important;
}

.br4 {
    border-radius: 4rpx;
}

.br8 {
    border-radius: 8rpx;
}

.br10 {
    border-radius: 10px;
}

.br20 {
    border-radius: 20px;
}

.br16 {
    border-radius: 16px;
}

.bold {
    font-weight: bold;
}

.flex-1 {
    flex: 1.3;
}

.flex1 {
    flex: 1;
}

.lin-1 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
}

.lin-3 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}

.lin-2 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.m-0 {
    margin: 0 !important
}

.mt-0,
.my-0 {
    margin-top: 0 !important
}

.mr-0,
.mx-0 {
    margin-right: 0 !important
}

.mb-0,
.my-0 {
    margin-bottom: 0 !important
}

.ml-0,
.mx-0 {
    margin-left: 0 !important
}

.m-1 {
    margin: .25rem !important
}

.mt-1,
.my-1 {
    margin-top: .25rem !important
}

.mr-1,
.mx-1 {
    margin-right: .25rem !important
}

.mb-1,
.my-1 {
    margin-bottom: .25rem !important
}

.ml-1,
.mx-1 {
    margin-left: .25rem !important
}

.m-2 {
    margin: .5rem !important
}

.mt-2,
.my-2 {
    margin-top: .5rem !important
}

.mr-2,
.mx-2 {
    margin-right: .5rem !important
}

.mb-2,
.my-2 {
    margin-bottom: .5rem !important
}

.ml-2,
.mx-2 {
    margin-left: .5rem !important
}

.m-3 {
    margin: 1rem !important
}

.mt-3,
.my-3 {
    margin-top: 1rem !important
}

.mr-3,
.mx-3 {
    margin-right: 1rem !important
}

.mb-3,
.my-3 {
    margin-bottom: 1rem !important
}

.ml-3,
.mx-3 {
    margin-left: 1rem !important
}

.m-4 {
    margin: 1.5rem !important
}

.mt-4,
.my-4 {
    margin-top: 1.5rem !important
}

.mr-4,
.mx-4 {
    margin-right: 1.5rem !important
}

.mb-4,
.my-4 {
    margin-bottom: 1.5rem !important
}

.ml-4,
.mx-4 {
    margin-left: 1.5rem !important
}

.m-5 {
    margin: 3rem !important
}

.mt-5,
.my-5 {
    margin-top: 3rem !important
}

.mr-5,
.mx-5 {
    margin-right: 3rem !important
}

.mb-5,
.my-5 {
    margin-bottom: 3rem !important
}

.ml-5,
.mx-5 {
    margin-left: 3rem !important
}

.p-0 {
    padding: 0 !important
}

.pt-0,
.py-0 {
    padding-top: 0 !important
}

.pr-0,
.px-0 {
    padding-right: 0 !important
}

.pb-0,
.py-0 {
    padding-bottom: 0 !important
}

.pl-0,
.px-0 {
    padding-left: 0 !important
}

.p-1 {
    padding: .25rem !important
}

.pt-1,
.py-1 {
    padding-top: .25rem !important
}

.pr-1,
.px-1 {
    padding-right: .25rem !important
}

.pb-1,
.py-1 {
    padding-bottom: .25rem !important
}

.pl-1,
.px-1 {
    padding-left: .25rem !important
}

.p-2 {
    padding: .5rem !important
}

.pt-2,
.py-2 {
    padding-top: .5rem !important
}

.pr-2,
.px-2 {
    padding-right: .5rem !important
}

.pb-2,
.py-2 {
    padding-bottom: .5rem !important
}

.pl-2,
.px-2 {
    padding-left: .5rem !important
}

.p-3 {
    padding: 1rem !important
}

.pt-3,
.py-3 {
    padding-top: 1rem !important
}

.pr-3,
.px-3 {
    padding-right: 1rem !important
}

.pb-3,
.py-3 {
    padding-bottom: 1rem !important
}

.pl-3,
.px-3 {
    padding-left: 1rem !important
}

.p-4 {
    padding: 1.5rem !important
}

.pt-4,
.py-4 {
    padding-top: 1.5rem !important
}

.pr-4,
.px-4 {
    padding-right: 1.5rem !important
}

.pb-4,
.py-4 {
    padding-bottom: 1.5rem !important
}

.pl-4,
.px-4 {
    padding-left: 1.5rem !important
}

.p-5 {
    padding: 3rem !important
}

.pt-5,
.py-5 {
    padding-top: 3rem !important
}

.pr-5,
.px-5 {
    padding-right: 3rem !important
}

.pb-5,
.py-5 {
    padding-bottom: 3rem !important
}

.pl-5,
.px-5 {
    padding-left: 3rem !important
}

.m-n1 {
    margin: -.25rem !important
}

.mt-n1,
.my-n1 {
    margin-top: -.25rem !important
}

.mr-n1,
.mx-n1 {
    margin-right: -.25rem !important
}

.mb-n1,
.my-n1 {
    margin-bottom: -.25rem !important
}

.ml-n1,
.mx-n1 {
    margin-left: -.25rem !important
}

.m-n2 {
    margin: -.5rem !important
}

.mt-n2,
.my-n2 {
    margin-top: -.5rem !important
}

.mr-n2,
.mx-n2 {
    margin-right: -.5rem !important
}

.mb-n2,
.my-n2 {
    margin-bottom: -.5rem !important
}

.ml-n2,
.mx-n2 {
    margin-left: -.5rem !important
}

.m-n3 {
    margin: -1rem !important
}

.mt-n3,
.my-n3 {
    margin-top: -1rem !important
}

.mr-n3,
.mx-n3 {
    margin-right: -1rem !important
}

.mb-n3,
.my-n3 {
    margin-bottom: -1rem !important
}

.ml-n3,
.mx-n3 {
    margin-left: -1rem !important
}

.m-n4 {
    margin: -1.5rem !important
}

.mt-n4,
.my-n4 {
    margin-top: -1.5rem !important
}

.mr-n4,
.mx-n4 {
    margin-right: -1.5rem !important
}

.mb-n4,
.my-n4 {
    margin-bottom: -1.5rem !important
}

.ml-n4,
.mx-n4 {
    margin-left: -1.5rem !important
}

.m-n5 {
    margin: -3rem !important
}

.mt-n5,
.my-n5 {
    margin-top: -3rem !important
}

.mr-n5,
.mx-n5 {
    margin-right: -3rem !important
}

.mb-n5,
.my-n5 {
    margin-bottom: -3rem !important
}

.ml-n5,
.mx-n5 {
    margin-left: -3rem !important
}

.w-100 {
    width: 100% !important;
}

.h-100 {
    height: 100% !important;
}

.border {
    border: 1px solid #dee2e6 !important
}

.border-top {
    border-top: 1px solid #dee2e6 !important
}

.border-right {
    border-right: 1px solid #dee2e6 !important
}

.border-bottom {
    border-bottom: 1px solid #dee2e6 !important
}

.border-left {
    border-left: 1px solid #dee2e6 !important
}

.bottom-dash {
    border-bottom: 1rpx dashed #f4f4f4 !important
}

.textColorRed {
    color: #EF1515;
}

.textColorGreen {
    color: #1BC974;
}

.textColorBlue {
    color: #1b67c9;
}

.mainBgColor {
    background-color: #EE3717 !important;
}

.mainTextColor {
    color: #EE3717;
}

.btnRadius {
    border-radius: 50rpx !important;
}

.bottomBtn {
    margin-top: 26px;
    padding: 10px;
    display: flex;
    border-radius: 10px;
    align-items: center;
    flex-direction: row;
    justify-content: center;
}

// 文字控制
.text-white-space {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    letter-spacing: 1rpx;
}

.text-white-space-line2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    letter-spacing: 1rpx;
}

.text-white-line2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

.white-space-nowrap {
    white-space: nowrap;
}

//灰色
.grey-color {
    color: #8f8f94;
}

.blue-color {
    color: #429aff;

}

.red-color {
    color: #f00;
}

.xing {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    line-height: 30px;
    font-size: 25px;
    color: #f00;
}

.el-pagination__total {
    margin-left: 20px !important;
}

.customDialog .el-dialog__header {
    background-color: #D51919;
    padding-top: 10px;
}

.customDialog .el-dialog__header .el-dialog__title {
    color: #fff;
}

.customDialog .el-dialog__headerbtn {
    top: 10px
}

.customDialog .el-dialog__headerbtn .el-dialog__close {
    color: #fff
}

.tableHeadStyle {
    background-color: #FBE7E7 !important;
    color: #000;
}

.el-input__inner {
    padding-right: 0;
}

/deep/ .el-dialog__headerbtn {
    /deep/ .el-dialog__close {
        color: #fff !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue